document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('.recipe-toc a');
  const sections = Array.from(links).map(l => document.querySelector(l.getAttribute('href')));

  function updateActive() {
    const mid = window.innerHeight / 2;
    sections.forEach((sec, i) => {
      const top = sec.getBoundingClientRect().top;
      links[i].classList.toggle('active', top <= mid && top >= -mid);
    });
  }

  window.addEventListener('scroll', updateActive);
  updateActive();
});
